import styled, { css } from 'styled-components';
import { ButtonSize } from 'styled-system';

const focussedContainer = css`
  border-color: ${({ theme }) => theme.brand.primary.base};
`;
const errorContainer = css`
  border-color: #cc2324; // TODO: use theme color
  color: #cc2324; // TODO: use theme color

  input::placeholder {
    color: #cc2324; // TODO: use theme color
  }
`;
const disabledContainer = css`
  background-color: #f2f2f2; // TODO: use theme color
  border-color: #d9d9d9; // TODO: use theme color
  color: #999; // TODO: use theme color
`;

export const Container = styled.div<{
  hasError?: boolean;
  disabled?: boolean;
  focused?: boolean;
  // can't just be given a theme token here as it is pulling from the native HTMLInput Element where height is declared as a string | number
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/height
  height?: string | number | keyof ButtonSize;
  padding?: string | number;
}>`
  display: flex;
  align-items: center;
  justify-content: stretch;
  height: ${({ height, theme }) =>
    typeof height === 'number'
      ? `${height}px`
      : theme.components.button.sizes[height as keyof ButtonSize] ||
        theme.components.button.sizes.m};
  background: #fff; // TODO: use theme color
  box-sizing: border-box;
  border: 1px solid #999; // TODO: use theme color
  border-radius: 4px; // TODO: use theme border radius
  color: #333; // TODO: use theme color
  padding: ${({ padding }) => padding}};
  ${({ focused }) => focused && focussedContainer};
  ${({ hasError }) => hasError && errorContainer};
  ${({ disabled }) => disabled && disabledContainer};
  &:has(input:disabled) {
    ${disabledContainer};
  }
`;

export const Input = styled.input`
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  padding: 0; // TODO: use theme spacing
  font: inherit;
  text-align: left;
  background: none;
  border: none;
  color: inherit;
  outline: none;
  line-height: 24px; //TODO: Use theme
  ::placeholder {
    color: #999; // TODO: use theme color
  }

  &:first-child {
    text-indent: ${({ theme }) => theme.spacing.M16};
  }
  &:not(:first-child) {
    text-indent: ${({ theme }) => theme.spacing.S8};
  }
`;

export const Leading = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  height: 100%;
  border-radius: 4px 0 0 4px; // TODO: use theme border radius
  overflow: hidden;
`;

export const Trailing = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  height: 100%;
  border-radius: 0 4px 4px 0; // TODO: use theme border radius
  overflow: hidden;
`;
